import products from "../views/products/index.vue";
import products_create from "../views/products/create.vue";
import products_edit from "../views/products/edit.vue";
import products_detail from "../views/products/detail.vue";
import products_import from "../views/products/import.vue";

const routes = [
  {
    path: "/products",
    name: "products",
    component: products,
    meta: { authOnly: true }
  },
  {
    path: "/products/create",
    name: "products_create",
    component: products_create,
    meta: { authOnly: true }
  },
  {
    path: "/products/edit/:uuid",
    name: "products_edit",
    component: products_edit,
    meta: { authOnly: true }
  },
  {
    path: "/products/detail/:uuid",
    name: "products_detail",
    component: products_detail,
    meta: { authOnly: true }
  },
  {
    path: "/products/import",
    name: "products_import",
    component: products_import,
    meta: { authOnly: true }
  }
];

export default routes;
